import React from 'react';
import PropTypes from 'prop-types'; 
import Link from 'gatsby-link';
import ScrollUpButton from "react-scroll-up-button";
//import BurgerMenu from 'react-burger-menu';

import '../assets/scss/main.scss'
import Header from '../components/Header'
import Menu from '../components/Menu'
import Contact from '../components/Contact'
import Footer from '../components/Footer'

import BurgerMenu from 'react-burger-menu';

const BMenu = BurgerMenu['pushRotate'];
//<Link key="2" to="/pack-e-commerce/"><i className="fa fa-fw fa-wordpress" /><span>Pack Site vitrine</span></Link>,
//<Link key="4" to="/hotspots-wifi/"><i className="fa fa-fw fa-wifi" /><span>Hotspots Wifi</span></Link>,
const items = [
    <Link key="0" to="/" title="Accueil"><i className="fa fa-fw fa-home" /><span>Accueil</span></Link>,
    <Link key="1" to="/infrastructure-informatique/" title="Intégration et audit systèmes d'informations"><i className="fa fa-fw fa-gear" /><span>Infrastructure</span></Link>,
    <Link key="2" to="/assistance-informatique/" title="Conseil et assistance informatique"><i className="fa fa-fw fa-support" /><span>Assistance</span></Link>,
    <Link key="3" to="/configuration-et-suivi-securite-informatique/" title="Suivi sécurité mensuel"><i className="fa fa-fw fa-shield" /><span>Suivi sécurité</span></Link>,
    <Link key="4" to="/creation-sites-internet-et-applications/" title="Création et référencement de sites web et d'applications"><i className="alticon-responsive" /><span>Sites & Applis</span></Link>,
    <Link key="5" to="/cv/" title="Mon curriculum vitae"><i className="fa fa-fw fa-graduation-cap" /><span>Mon CV</span></Link>
];


class Template extends React.Component {

    constructor(props) {
        super(props);
        this.browser = this.getBrowser();
        this.browserCompatibility = this.browser && this.browser.name == "IE" && this.browser.version < 11 ? false : true;
        //this.browserCompatibility = false;
        this.state = {
            isMenuVisible: false,
            loading: 'is-loading'
        }
        this.handleToggleMenu = this.handleToggleMenu.bind(this);
		//this.handleStateChange = this.handleStateChange.bind(this);
    }

    componentDidMount() {
        this.timeoutId = setTimeout(() => {
            this.setState({ loading: '' });
        }, 100);
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    handleToggleMenu() {
        this.setState({
            isMenuVisible: !this.state.isMenuVisible
        })
    }
	handleStateChange (state) {
    	this.setState({isMenuVisible: state.isOpen})  
  	}
    getBrowser() {
        if (typeof (window) !== 'undefined') {
            var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: (tem[1] || '') };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\bOPR|Edge\/(\d+)/)
                if (tem != null) { return { name: 'Opera', version: tem[1] }; }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
            return {
                name: M[0],
                version: M[1]
            };
        }
    }

    render() {
        const { children } = this.props
        //const BMenu = BurgerMenu['push'];
        //<div className="right"><BMenu id='pushRotate' isOpen={this.state.isMenuVisible} pageWrapId={'wrapper'} outerContainerId={'root'} right>{items}</BMenu></div>

        //		 <Menu onToggleMenu={this.handleToggleMenu} />
        //<ScrollUpButton />
        return (
            <div id='root' className={`body ${this.state.loading} ${this.state.isMenuVisible ? 'is-menu-visible' : ''}`}>
				<BMenu id='pushRotate' isOpen={this.state.isMenuVisible} pageWrapId={'wrapper'} outerContainerId={'root'} >{items}</BMenu>
                    {!this.browserCompatibility && <div id="alert"><span className="alert"><i className="icon fa-exclamation-triangle stretch"></i> Votre navigateur {this.browser.name} V{this.browser.version} est trop ancien</span></div>}
                <div id="wrapper">
                    <Header />
                    {children()}
                    <Contact />
                    <Footer />
                </div>
                <ScrollUpButton />
            </div>
        )
    }
}

Template.propTypes = {
    children: PropTypes.func
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js